<template>
  <div
    @mouseenter="enter"
    @mouseleave="leave"
    class="menu-container"
    ref="menu"
    :class="{
      collapse: isCollapse,
      show: !isCollapse,
    }"
  >
    <div class="lf flex-center">
      <router-link
        v-for="item in lfArr"
        :key="item.link"
        :to="{ name: item.name }"
        :exact="item.exact"
        class="big"
        active-class="active"
        exact-active-class=""
      >
        <div class="title">
          {{ item.title }}
        </div>
        <Icon :type="item.icon" />
      </router-link>
    </div>
    <div class="rt flex-center">
      <a
        v-for="item in rtArr"
        :key="item.icon"
        class="big"
        @click="handleRt(item)"
      >
        <div class="title">
          {{ item.title }}
        </div>
        <Icon :type="item.icon" />
      </a>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  props: {
    lfArr: {
      type: Array,
      default: () => [],
    },
    rtArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    isCollapse() {
      return this.$route.name === "Home" || this.$route.name === null;
    },
  },
  methods: {
    enter(e) {
      if (this.isCollapse) {
        e.target.style.transform = "translate(-50%, 20px)";
        e.target.style.opacity = "1";
      }
    },
    leave(e) {
      if (this.isCollapse) {
        e.target.style.transform = "translate(-50%, -5px)";
        e.target.style.opacity = "0";
      }
    },
    handleRt(item) {
      this.$emit("handleRt", item);
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/mixin.less";
@import "~@/styles/common.less";
.menu-container {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 20px);
  height: 50px;
  width: 60vw;
  border-radius: 999px;
  padding: 0 12px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  z-index: 999;
  background: #fff;
  color: @lightWords;
  opacity: 0;
  overflow-y: visible;
  .flex-between();
  &.collapse {
    transform: translate(-50%, -5px);
    transition: 0.4s;
    opacity: 0;
  }
  &.show {
    opacity: 1;
  }
  a {
    position: relative;
    color: @gray;
    margin: 0 6px;
    .flex-center();
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: inherit;
    cursor: pointer;
    transition: 0.5s;
    .title {
      position: absolute;
      white-space: nowrap;
      padding: 0 5px;
      top: 45px;
      background: #fff;
      transform: translateY(10px);
      transition: 0.5s;
      opacity: 0;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      border-radius: 5px;
      color: @gray;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }
    &.active {
      background-color: #dadfe5;
      color: @primary;
      font-weight: bold;
    }
    &:hover {
      color: @primary;
      transform: scale(1.2);
      .title {
        color: @gray;
        transform: translateY(0) scale(0.83);
        opacity: 1;
      }
    }
  }
}
</style>
